var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "app/views/modal/info_modal.component";
var LogsModalComponent = /** @class */ (function (_super) {
    __extends(LogsModalComponent, _super);
    function LogsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.paymentTypeMap = {
            99: 'Оплачено безналом',
            999: 'Даётся бесплатно',
            9999: 'Номер заказа Divly',
        };
        _this.periodTypeMap = {
            1: 'Предустановленные',
            2: 'Произвольная дата окончани',
            3: 'Произвольное количество дней',
        };
        return _this;
    }
    LogsModalComponent.prototype.ok = function () {
        this.close();
    };
    return LogsModalComponent;
}(InfoModalComponent));
export { LogsModalComponent };
